import React from 'react';

const Blog1 = () => {
    return (
        <div>
            <h1>Welcome to Blog1</h1>
            <p>This is the content for Blog1 page.</p>
        </div>
    );
};

export default Blog1;
